import React, {useEffect, useState} from "react"
import { navigate } from "gatsby"
import { connect } from "react-redux"
import { Container, Row, Col } from "reactstrap"

import { motion, AnimatePresence } from "framer-motion"

import Dragger from "../../components/global/dragger"
import NavClock from "../../components/global/navClock"
import circle from "../../images/icon/circle.svg"

import { setLogoTheme } from "../../state/navbar"

const NavBar = ({ logoTheme, shop, dispatch, containerRef }) => {
  const themes = ["white", "black", "green"]
  const [headerInView, setHeaderInView] = useState(true);

  useEffect(() => {
    if (containerRef) {
      containerRef.current.addEventListener('scroll', event => {
        if (headerInView !== event.target.scrollTop < 160) {
          setHeaderInView(event.target.scrollTop < 160)
        }
      })
    }
  })

  function _advanceTheme() {
    const index = themes.indexOf(logoTheme)
    const endOfLoop = index === themes.length - 1
    dispatch(setLogoTheme(endOfLoop ? themes[0] : themes[index + 1]))
  }

  return (
    <Container fluid>
      <Row id="navbar">
        <Col
          xs="1"
          md="2"
          className={"d-flex align-items-center justify-content-start"}
        > 
          {shop ? (
            <div
              role="button"
              className="shop-button__back "
              tabIndex={0}
              onClick={() => navigate("/")}
            >
              <img src={circle} id="navCircle" alt="theme switcher circle" />
              <span>BACK</span>
              <span>&nbsp;TO RAD</span>
            </div>
          ) : (
            <div
              role="button"
              tabIndex={0}
              onClick={() => _advanceTheme()}
              onKeyDown={() => _advanceTheme()}
            >
              <img src={circle} id="navCircle" alt="theme switcher circle" />
            </div>
          )}
        </Col>
        <Col
          xs="10"
          md="8"
          className="d-flex align-items-center justify-content-center"
        >
          <NavClock />
        </Col>
        <Col
          xs="1"
          md="2"
          className="d-flex align-items-center justify-content-end"
        >
          <Dragger />
        </Col>
      </Row>
      <AnimatePresence>
        { shop && !headerInView && (
          <motion.div
            role="button"
            tabIndex={0}
            onClick={() => navigate("/")}
            
            className={`shop-button__back--fixed`}
            transition={{ duration: .3 }}
            initial={{ y: "-30px", opacity: 0 }}
            animate={{ y: "0", opacity: 1 }}
            exit={{ y: "0", opacity: 0 }}
          >
            <span>BACK</span>
            <span>&nbsp;TO RAD</span>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        { shop && !headerInView && (
          <motion.div
            role="button"
            tabIndex={0}
            onClick={() => {
              containerRef.current.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              }); 
            }}
            
            className={`shop-button__top--fixed`}
            transition={{ duration: .3 }}
            initial={{ y: "-30px", opacity: 0 }}
            animate={{ y: "0", opacity: 1 }}
            exit={{ y: "0", opacity: 0 }}
          >
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20" cy="20" r="20" fill="white"/>
              <path d="M25.7548 18.8018L19.953 13L14.1512 18.8018" stroke="black" strokeWidth="2" strokeMiterlimit="10"/>
              <path d="M19.953 13V26.6713" stroke="black" strokeWidth="2" strokeMiterlimit="10"/>
            </svg>
          </motion.div>
        )}
      </AnimatePresence>
    </Container>
  )
}

export default connect(
  state => ({
    mobile: state.global.mobile,
    logoTheme: state.navbar.logoTheme,
  }),
  null
)(NavBar)
